import { ArrowRight, Loader2, type LucideIcon } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * The ONE next action for the broker/carrier on an awarded dispatch.
 *
 * Terminology and target milestone come from `milestoneActions.ts`, so this bar
 * and the amber circle in the progress tracker always describe the same step.
 */
interface Props {
  label: string;
  hint: string;
  icon: LucideIcon;
  busy?: boolean;
  onClick: () => void;
}

export function NextUpActionBar({ label, hint, icon: Icon, busy, onClick }: Props) {
  return (
    <div className="rounded-lg border border-border bg-card shadow-sm px-3 py-3 flex items-center justify-between gap-3 flex-wrap">
      <div className="flex items-center gap-3 min-w-0">
        <div className="h-9 w-9 shrink-0 rounded-full bg-orange-100 flex items-center justify-center">
          <Icon className="h-4 w-4 text-orange-600" />
        </div>
        <div className="min-w-0">
          <div className="text-sm font-semibold text-foreground truncate">
            Next up: {label}
          </div>
          <div className="text-xs text-muted-foreground">{hint}</div>
        </div>
      </div>
      <Button
        size="sm"
        onClick={onClick}
        disabled={busy}
        className="gap-1.5 w-full sm:w-auto h-11 sm:h-9 px-5 bg-orange-500 hover:bg-orange-600 text-white shadow-sm"
      >
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Icon className="h-4 w-4" />}
        {busy ? "Updating…" : label}
        {!busy && <ArrowRight className="h-4 w-4" />}
      </Button>
    </div>
  );
}

export default NextUpActionBar;
